import styled, { css } from "styled-components"
import { Link } from "react-router-dom"

import InputBase from "../InputBase"

export default function Button({ label, disabled, wrapperStyle, labelStyle, children, ...rest }) {
  return (
    <InputBase wrapperStyle={wrapperStyle}>
      {label && <Label>{label}</Label>}
      <div>
        {rest.to ? (
          <LinkStyle {...rest}>{children}</LinkStyle>
        ) : (
          <ButtonStyle {...rest} disabled={disabled}>
            {children}
          </ButtonStyle>
        )}
      </div>
    </InputBase>
  )
}

const Label = styled.label`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  margin-bottom: calc(100vw * (13 / 375));
`

const buttonStyle = css`
  cursor: pointer;
  padding: calc(100vw * (16 / 375)) 0;
  background: #ffcf19;
  border-radius: calc(100vw * (5 / 375));
  font-weight: 700;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19.2 / 375));
  color: #121212;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      width: 100%;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      background: #d8d8d8;
      color: #989898;
    `}
`

const ButtonStyle = styled.button`
  ${buttonStyle}
`

const LinkStyle = styled(Link)`
  ${buttonStyle}
`
